import React, { ReactNode, useContext, useState } from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import {
    Button,
    DownIcon,
    FilterContentWrapper,
    FilterGroupWrapper,
    FilterSubtitle,
    TextInputGroup,
    InputsGroupWrapper,
    MobileFiltersWrapper,
    SearchButton,
    Title,
    UpIcon,
} from './MobileFilterBoxStyle';
import { InputWrapper, RadioButton } from '../FilterBox/FilterBoxStyle';
import { ProductSearchResultsContext } from '../../../../context/ProductSearchResultsContext';
import { LANGUAGES_IMPERIAL_UNITS } from '../../../../constants/commonConstants';

const MobileFilterBox = ({ filtersName, filters }) => {
    const { t } = useTranslation();
    const { language } = useI18next();
    const [isActive, setIsActive] = useState(false);
    const {
        typeFilter,
        setTypeFilter,
        modeFilter,
        setModeFilter,
        pressureRangeFilter,
        setPressureRangeFilter,
        heatRecoveryFilter,
        setHeatRecoveryFilter,
        soundAbsorptionFilter,
        setSoundAbsorptionFilter,
        deliveryControlFilter,
        setDeliveryControlFilter,
        coolingFilter,
        setCoolingFilter,
        otherFilter,
        setOtherFilter,
        setCompressionModeUnits,
        motorPowerMinFilter,
        setMotorPowerMinFilter,
        motorPowerMaxFilter,
        setMotorPowerMaxFilter,
        fedMinFilter,
        setFedMinFilter,
        fedMaxFilter,
        setFedMaxFilter,
        setIsFiltersSubmit,
        setIsMobileView,
    } = useContext(ProductSearchResultsContext);
    const itemKey = 0;
    const itemValue = 1;
    const equipmentFiltersLabel = ['heatRecovery', 'soundAbsorption', 'deliveryControl', 'cooling', 'otherProperties'];
    const labelForEu = 'Motor power kW';
    const labelForUs = 'Motor power HP';
    const compressionModeFilters = [
        [+motorPowerMinFilter, setMotorPowerMinFilter],
        [+motorPowerMaxFilter, setMotorPowerMaxFilter],
        [+fedMinFilter, setFedMinFilter],
        [+fedMaxFilter, setFedMaxFilter],
    ];
    const motorPowerMin = 0;
    const motorPowerMax = 1;
    const FedMin = 2;
    const FedMax = 3;
    const valueOfFilter = 0;
    const setFilter = 1;

    const saveFilterToContext = (label: string, value: any) => {
        switch (label) {
            case 'type':
                return setTypeFilter((prevState) => prevState !== value && value);
            case 'mode':
                return setModeFilter((prevState) => prevState !== value && value);
            case 'pressure_range':
                return setPressureRangeFilter((prevState) => prevState !== value && value);
            case 'heat_recovery':
                return setHeatRecoveryFilter((prevState) => prevState !== value && value);
            case 'sound_absorption':
                const soundAbsorptionIndex = soundAbsorptionFilter.indexOf(value);
                if (soundAbsorptionIndex === -1) {
                    return setSoundAbsorptionFilter((prevState) => [...prevState, value]);
                } else {
                    return setSoundAbsorptionFilter((prevState) => {
                        prevState.splice(soundAbsorptionIndex, 1);
                        return [...prevState];
                    });
                }
            case 'delivery_control':
                const deliveryControlIndex = deliveryControlFilter.indexOf(value);
                if (deliveryControlIndex === -1) {
                    return setDeliveryControlFilter((prevState) => [...prevState, value]);
                } else {
                    return setDeliveryControlFilter((prevState) => {
                        prevState.splice(deliveryControlIndex, 1);
                        return [...prevState];
                    });
                }
            case 'cooling':
                const coolingIndex = coolingFilter.indexOf(value);
                if (coolingIndex === -1) {
                    return setCoolingFilter((prevState) => [...prevState, value]);
                } else {
                    return setCoolingFilter((prevState) => {
                        prevState.splice(coolingIndex, 1);
                        return [...prevState];
                    });
                }
            case 'others':
                const otherIndex = otherFilter.indexOf(value);
                if (otherIndex === -1) {
                    return setOtherFilter((prevState) => [...prevState, value]);
                } else {
                    return setOtherFilter((prevState) => {
                        prevState.splice(otherIndex, 1);
                        return [...prevState];
                    });
                }
            default:
                return '';
        }
    };

    const checkIfIsChecked = (label: string, value: any): boolean => {
        switch (label) {
            case 'type':
                return typeFilter === value;
            case 'mode':
                return modeFilter === value;
            case 'pressure_range':
                return pressureRangeFilter === value;
            case 'heat_recovery':
                return heatRecoveryFilter === value;
            case 'sound_absorption':
                return soundAbsorptionFilter.indexOf(value) !== -1;
            case 'delivery_control':
                return deliveryControlFilter.indexOf(value) !== -1;
            case 'cooling':
                return coolingFilter.indexOf(value) !== -1;
            case 'others':
                return otherFilter.indexOf(value) !== -1;
            default:
                return false;
        }
    };

    const onInputKeyPress = (event) => !/[0-9]/.test(event.key) && event.preventDefault();

    const onInputKeyUp = (event, maxValue, label) => {
        if (event.target.value > maxValue) {
            event.target.value = maxValue;

            if (label === labelForUs || label === labelForEu) {
                compressionModeFilters[motorPowerMax][setFilter](+event.target.value);
            } else {
                compressionModeFilters[FedMax][setFilter](+event.target.value);
            }
        }
    };

    const displayCompressionModeFiltersInputs = (item: any, indexNumber: number) => {
        return (
            <InputsGroupWrapper key={indexNumber}>
                {Object.entries(item)?.map((item: any, index: number) => (
                    <TextInputGroup key={index}>
                        <p>{t(`${item[itemKey]}`)}</p>
                        <label htmlFor={`${item[itemKey]}min`}>From</label>
                        <input
                            type="text"
                            id={`${item[itemKey]}min`}
                            name={`${item[itemKey]}min`}
                            maxLength={item[itemValue].max.length}
                            onKeyPress={onInputKeyPress}
                            onKeyUp={(e) => onInputKeyUp(e, +item[itemValue].max, item[itemValue].label)}
                            value={
                                item[itemValue].label === labelForUs || item[itemValue].label === labelForEu
                                    ? compressionModeFilters[motorPowerMin][valueOfFilter]
                                    : compressionModeFilters[FedMin][valueOfFilter]
                            }
                            onInput={(e: any) => {
                                item[itemValue].label === labelForUs || item[itemValue].label === labelForEu
                                    ? compressionModeFilters[motorPowerMin][setFilter](+e.target.value)
                                    : compressionModeFilters[FedMin][setFilter](+e.target.value);
                            }}
                        />
                        <label htmlFor={`${item[itemKey]}max`}>To</label>
                        <input
                            type="text"
                            id={`${item[itemKey]}max`}
                            name={`${item[itemKey]}max`}
                            maxLength={item[itemValue].max.length}
                            onKeyPress={onInputKeyPress}
                            onKeyUp={(e) => onInputKeyUp(e, +item[itemValue].max, item[itemValue].label)}
                            value={
                                item[itemValue].label === labelForUs || item[itemValue].label === labelForEu
                                    ? compressionModeFilters[motorPowerMax][valueOfFilter]
                                    : compressionModeFilters[FedMax][valueOfFilter]
                            }
                            onInput={(e: any) => {
                                item[itemValue].label === labelForUs || item[itemValue].label === labelForEu
                                    ? compressionModeFilters[motorPowerMax][setFilter](+e.target.value)
                                    : compressionModeFilters[FedMax][setFilter](+e.target.value);
                            }}
                        />
                    </TextInputGroup>
                ))}
            </InputsGroupWrapper>
        );
    };

    const checkMobileFiltersInputType = (
        widget: string,
        item: any,
        index: number,
        filterName: string,
        label: string
    ): ReactNode => {
        switch (widget) {
            case 'checkboxes':
                if (filterName === 'equipment') {
                    return (
                        <FilterContentWrapper key={index}>
                            <span>{t(equipmentFiltersLabel[index])}</span>
                            {Object.entries(item[itemKey])?.map((item: any, index: number) => (
                                <InputWrapper key={index}>
                                    <input
                                        type="checkbox"
                                        id={item[itemKey]}
                                        name={item[itemKey]}
                                        value={item[itemKey]}
                                        onClick={(e: any) => saveFilterToContext(label, e.target.value)}
                                        checked={checkIfIsChecked(label, item[itemKey])}
                                        onChange={() => {}}
                                    />
                                    <label htmlFor={item[itemKey]}>{t(`${item[itemKey]}`)}</label>
                                </InputWrapper>
                            ))}
                        </FilterContentWrapper>
                    );
                } else {
                    return (
                        <FilterContentWrapper key={index}>
                            {Object.entries(item[itemKey])?.map((item: any, index: number) => (
                                <InputWrapper key={index}>
                                    <input
                                        type="checkbox"
                                        id={item[itemKey]}
                                        name={item[itemKey]}
                                        value={item[itemKey]}
                                        onClick={(e: any) => {
                                            saveFilterToContext(label, e.target.value);
                                        }}
                                        checked={checkIfIsChecked(label, item[itemKey])}
                                        onChange={() => {}}
                                    />
                                    <label htmlFor={item[itemKey]}>{t(`${item[itemKey]}`)}</label>
                                </InputWrapper>
                            ))}
                        </FilterContentWrapper>
                    );
                }
            case 'radio':
                return (
                    <FilterContentWrapper key={index}>
                        {Object.entries(item[itemKey])?.map((item: any, index: number) => (
                            <RadioButton key={index} htmlFor={item[itemKey]}>
                                {t(`${item[itemKey]}`)}
                                <input
                                    type="radio"
                                    id={item[itemKey]}
                                    name={widget}
                                    value={item[itemKey]}
                                    onClick={(e: any) => saveFilterToContext(label, e.target.value)}
                                    checked={checkIfIsChecked(label, item[itemKey])}
                                    onChange={() => {}}
                                />
                                <span></span>
                            </RadioButton>
                        ))}
                    </FilterContentWrapper>
                );
            case 'slider':
                if (LANGUAGES_IMPERIAL_UNITS.indexOf(language) === -1 && item?.metric) {
                    return (
                        <FilterContentWrapper key={index}>
                            {displayCompressionModeFiltersInputs(item.metric, index)}
                        </FilterContentWrapper>
                    );
                } else if (LANGUAGES_IMPERIAL_UNITS.indexOf(language) !== -1 && item?.imperial) {
                    return (
                        <FilterContentWrapper key={index}>
                            {displayCompressionModeFiltersInputs(item.imperial, index)}
                        </FilterContentWrapper>
                    );
                } else {
                    return '';
                }
            default:
                return '';
        }
    };

    const displayFiltersContent = (): ReactNode =>
        filters?.map((item: any, index: number) => {
            const currentFilterName = filtersName[index];
            return (
                <FilterGroupWrapper key={index}>
                    <FilterSubtitle>{t(currentFilterName)}</FilterSubtitle>
                    {item.map((item: any, index: number) =>
                        checkMobileFiltersInputType(item.widget, item, index, currentFilterName, item.label)
                    )}
                </FilterGroupWrapper>
            );
        });

    const searchResults = (): void => {
        setIsFiltersSubmit(true);
        setIsActive((isActive) => !isActive);
        setIsMobileView((isMobileView) => !isMobileView);

        if (LANGUAGES_IMPERIAL_UNITS.indexOf(language) === -1) {
            setCompressionModeUnits('metric');
        } else {
            setCompressionModeUnits('imperial');
        }
    };

    const changeFilterActive = (): void => {
        setIsActive((isActive) => !isActive);
        setIsMobileView((isMobileView) => !isMobileView);
    };

    return (
        <MobileFiltersWrapper>
            {isActive && (
                <>
                    <Title>{t('refineSearch')}</Title>
                    {displayFiltersContent()}
                    <SearchButton onClick={searchResults}>{t('search')}</SearchButton>
                </>
            )}
            <Button onClick={changeFilterActive}>
                {isActive ? (
                    <>
                        {t('closeFilter')} <UpIcon />
                    </>
                ) : (
                    <>
                        {t('refineSearch')} <DownIcon />
                    </>
                )}
            </Button>
        </MobileFiltersWrapper>
    );
};

export default MobileFilterBox;
